import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Ad } from './cp-dc.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class VideoPopupService {
  private videoSubject$ = new BehaviorSubject<Ad>(null);
  private openVideoAdd$ = new BehaviorSubject<boolean>(null);
  videoSub$ = this.videoSubject$.asObservable();
  openVideoAddModal$ = this.openVideoAdd$.asObservable();
  constructor(private location: Location) {
    // Listen for popstate events
    window.addEventListener('popstate', () => {
      if (this.openVideoAdd$.value) {
        this.updateOpenVideoAddSub(false);
        // Push the state back to avoid navigation
        history.pushState(null, null, window.location.href);
      }
    });
  }

  updateVideoSub(data:Ad) : void {
    this.videoSubject$.next(data);
  }

  updateOpenVideoAddSub(data: boolean) : void {
    if (data) {
      // Push a new state into the browser history only when opening the popup
      history.pushState(null, null, window.location.href);
    }
    this.openVideoAdd$.next(data);
  }
}
